import styles from './footer.module.sass'
import Nav from './nav'
import Image from '../basic/image'
import ScrollAnimation from '../layout/scroll_animation'

const globalData = JSON.parse(document.getElementById('global-data').innerHTML)
const navData = JSON.parse(document.getElementById('nav-data').innerHTML.replace('&#038;', '&'))

function Footer({items}) {

	return <div className={styles.footer}>
		<div className={styles.full_bleed}></div>
		<ScrollAnimation styles={styles}>
			<div className={styles.footer_wrapper}>

				<div className={styles.nav_wrapper}>
					<Image {...globalData?.global_settings?.logo} className={styles.footer_logo} />
					<Nav items={navData.main_items} type='footer' className={styles.footer_nav} />
				</div>

				<div className={styles.copyright_wrapper}>

					<div className={styles.copyright} dangerouslySetInnerHTML={{__html: `©${new Date().getFullYear()}  ${globalData?.global_settings?.copyright_text}`}}></div>

					<div className={styles.footer_menu_wrapper}>
						<Nav items={navData.copyright_items} type='copyright' className={styles.copyright_nav} />

						<div className={styles.social_wrapper}>
							{globalData?.global_settings?.social_media && <ul>
								{globalData?.global_settings?.social_media.map((social, index) => {
								return <li key={index} className={styles[social.platform]}>
									<a href={social.link} target='_blank' aria-label={social.platform}><Image {...{url: `https://www.personalis.com/wp-content/themes/personalis/assets/icons/social/${social.platform}-white.svg`}} alt="Social Link" className={styles.social_logo} /></a>
								</li>
								})}
							</ul>}
						</div>
					</div>

				</div>
			</div>
		</ScrollAnimation>
	</div>
}

export default Footer